import { Image, makeStyles, tokens } from "@fluentui/react-components";
import { SpinnerIos20Regular } from "@fluentui/react-icons";
import * as React from "react";
import { spinAnimation } from "@/utils/animations";

export const SigningIn: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Image src="/assets/aiir-logo.svg" alt="Aiir" width={"128px"} />
      <div className={styles.loading_container}>
        <SpinnerIos20Regular className={styles.loading_spinner} />
        <p>Signing In...</p>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    gap: "24px",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  loading_container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    paddingTop: "32px",
  },
  loading_spinner: {
    animationName: spinAnimation,
    animationDuration: "1.5s",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
  },
});
